/**
 * @file Looks up the beneficiary name of a project's bank account for export.
 */
import type { Project, BankAccountsMap } from "../types";

/**
 * Returns the beneficiary name of the bank account linked to a project, or an empty string.
 */
const getBeneficiary = (bankAccountsMap: BankAccountsMap, project: Project): string => {
  const { bankAccountId } = project;

  if (!bankAccountId) {
    return "";
  }

  const bankAccount = bankAccountsMap[bankAccountId];

  if (!bankAccount) {
    return "";
  }

  const { beneficiaryName } = bankAccount;

  return beneficiaryName;
};

export default getBeneficiary;
